/**
 * Copyright © WarmHeart Intelligence Technology Group (Jiangsu) Co.,Ltd Company, Limited.
 * All Rights Reserved
 */
import url from "./conf";
import {post, tokenPost} from "./ajax";

const staff = {
  /**
   *  AJAX-添加员工
   * @param info
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  add(info, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.ADD_STAFF,
      {
        staffNum : info.num,
        staffName : info.name,
        staffMobileno : info.mobileNo,
        staffSex : info.sexId,
        staffAge : info.age,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-修改员工
   * @param info
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  modify(info, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.MODIFY_STAFF,
      {
        staffNum : info.num,
        staffName : info.name,
        staffMobileno : info.mobileNo,
        staffSex : info.sexId,
        staffAge : info.age,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-分页获取员工列表
   * @param search
   * @param page
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  listStaff(search, page, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.LIST_STAFF,
      {
        num: search.id,
        name: search.name,
        isStop: search.statusId,
        pageIndex: page.pagination,
        pageSize: page.size,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-获取员工详情
   *  @param num
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  acquire(num, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.ACQUIRE_STAFF,
      {
        num: num,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-启用/停用员工
   * @param num
   * @param flag
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  stop(num, flag, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.STOP_STAFF,
      {
        num: num,
        flag: flag,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-保存角色
   * @param num
   * @param roleIds
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  addRole(num,roleIds, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.ADD_ROLE_STAFF,
      {
        num : num,
        roleIds : roleIds,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-保存所属角色
   * @param num
   * @param moduleType
   * @param moduleIds
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  addModule(num,moduleType,moduleIds, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.ADD_MODULE,
      {
        num : num,
        moduleType : moduleType,
        moduleIds: moduleIds,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-重置员工密码
   *  @param num
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  resetPassword(num, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.RESET_PASSWORD,
      {
        num: num,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
}

export default staff;



// WEBPACK FOOTER //
// ./src/assets/ajax/ajax-staff.js